module.exports = __webpack_public_path__ + "static/media/55_000042.19d92bcb.jpg";